"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = exports.ButtonType = exports.ButtonVariant = void 0;
var theme_ui_1 = require("theme-ui");
var __1 = require("../../..");
var ButtonVariant;
(function (ButtonVariant) {
    ButtonVariant["PRIMARY"] = "primary";
    ButtonVariant["LARGE"] = "large";
    ButtonVariant["SECONDARY"] = "secondary";
    ButtonVariant["TERTIARY"] = "tertiary";
    ButtonVariant["TERTIARY_WITHOUT_CHEVRON"] = "tertiaryWithoutChevron";
    ButtonVariant["OVERFLOW"] = "overflow";
})(ButtonVariant = exports.ButtonVariant || (exports.ButtonVariant = {}));
var ButtonType;
(function (ButtonType) {
    ButtonType["BUTTON"] = "button";
    ButtonType["SUBMIT"] = "submit";
    ButtonType["RESET"] = "reset";
})(ButtonType = exports.ButtonType || (exports.ButtonType = {}));
function Button(_a) {
    var onClick = _a.onClick, children = _a.children, _b = _a.variant, variant = _b === void 0 ? ButtonVariant.PRIMARY : _b, buttonType = _a.buttonType, csx = _a.csx, disabled = _a.disabled, onMouseOver = _a.onMouseOver, onMouseOut = _a.onMouseOut, htmlName = _a.htmlName, dataTestId = _a.dataTestId, restProps = __rest(_a, ["onClick", "children", "variant", "buttonType", "csx", "disabled", "onMouseOver", "onMouseOut", "htmlName", "dataTestId"]);
    return (theme_ui_1.jsx(theme_ui_1.Button, __assign({ type: buttonType, disabled: disabled || false, variant: variant, onClick: onClick, name: htmlName, "data-testid": dataTestId, sx: __assign({ cursor: disabled ? "not-allowed" : "pointer" }, csx), onMouseOver: onMouseOver || (function () { }), onMouseOut: onMouseOut || (function () { }) }, restProps, { "data-test": dataTestId }),
        children,
        variant === ButtonVariant.TERTIARY && theme_ui_1.jsx(__1.Chevron, null)));
}
exports.Button = Button;
Button.defaultProps = {
    variant: ButtonVariant.PRIMARY,
    disabled: false
};
